import React from "react"

interface SimpleButtonProps {
    label: string,
    className?: string,
    onClick?: () => void
}

export class SimpleButton extends React.Component<SimpleButtonProps, {}> {
    render() {
        return (
            <div className={"button-action center " + this.props.className}>
                <button className={"btn btn-primary"} onClick={this.props.onClick}>{this.props.label}</button>
            </div>
        )
    }
}